import React from 'react';
import PropTypes from 'prop-types';
import {
  SimpleModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@ami/react/core';
import { Button } from '@ami/react/core';
import { DealerBranch } from '../../../dealer-branches/dealerBranch';
import { Quote } from '../../../quotes/quote';
import QuoteView from '../quoteView';
import NotificationSettings from '../../../notificationSettings';
import { User } from '../../../users/user';
import { DealerUserFilter } from '../../../dealer-users/dealerUserFilter';
import { Team } from '../../../teams/team';
import { DealerGroup } from '../../../dealer-groups/dealerGroup';
import { dealerUserService } from '../../../dealer-users/dealerUserService';
import { Spinner } from '@ami/react/core';
import { NotificationSettingsComponent } from '../../../NotificationSettingsComponent';

export default class ReSendCreateNotificationModal extends React.Component {
  state = {
    show: false,
    loading: false,
    sending: false,
    // The properties below are used in the notification settings modal.
    dealerGroup: null,
    dealerUsers: [],
    amiUsers: [],
    dealerBranchSalesTeam: null,
    notificationSettings: new NotificationSettings(),
  };

  static propTypes = {
    quote: PropTypes.instanceOf(QuoteView).isRequired,
    onSent: PropTypes.func.isRequired,
  };

  show = () => this.setState({ show: true });
  hide = () => this.setState({ show: false });

  send = () => {
    this.setState({ sending: true });
    Quote.reSendCreateNotification(
      this.props.quote.id,
      this.state.notificationSettings
    )
      .then(() => {
        this.props.onSent();
        this.hide();
      })
      .finally(() => this.setState({ sending: false }));
  };

  updateNotificationSettings = (notificationSettings) => {
    this.setState({ notificationSettings });
  };

  async componentDidUpdate(prevProps, prevState) {
    if (!prevState.show && this.state.show) {
      const { dealerInformation } = this.props.quote;
      this.setState({ loading: true });
      const dealerBranch = await DealerBranch.getById(
        dealerInformation.dealerBranchId
      );
      this.setState({
        dealerBranch,
        dealerUsers: await dealerUserService.search(
          new DealerUserFilter({ dealerGroupId: dealerBranch.dealerGroupId })
        ),
        dealerGroup: await DealerGroup.getById(dealerBranch.dealerGroupId),
        amiUsers: await User.search(),
        dealerBranchSalesTeam: await Team.getById(dealerBranch.salesTeamId),
        loading: false,
      });
    }
  }

  render() {
    const {
      show,
      loading,
      dealerBranch,
      dealerGroup,
      dealerUsers,
      amiUsers,
      dealerBranchSalesTeam,
      notificationSettings,
    } = this.state;
    if (!show) return null;
    const { quote } = this.props;

    return (
      <SimpleModal show={show} size="lg">
        <ModalHeader title="Resend Notification" />
        <ModalBody>
          <form className="container">
            <Spinner show={loading} />
            {dealerGroup && (
              <div className="row">
                <div className="col">
                  <NotificationSettingsComponent
                    isEmailCommunicationEnabled={
                      dealerGroup.isEmailCommunicationEnabled
                    }
                    dealerGroupId={dealerGroup.id}
                    dealerGroupUsers={dealerUsers}
                    dealerUser={dealerUsers.find(
                      (x) => x.id === quote.dealerInformation.dealerUserId
                    )}
                    amiUsers={amiUsers.filter(
                      (x) =>
                        x.id === quote.salesPersonId ||
                        x.id === quote.territoryManagerInformation.userId ||
                        dealerBranchSalesTeam.amiUserIds.includes(x.id) ||
                        quote.subscribedAmiUserIds.includes(x.id)
                    )}
                    isEditMode={false}
                    notificationSettings={notificationSettings}
                    onNotificationSettingsUpdate={
                      this.updateNotificationSettings
                    }
                    entityName="Quote"
                    defaultDealerContactIds={
                      dealerBranch.defaultDealerContactIds
                    }
                    enabledNotificationSchedule={false}
                  />
                </div>
              </div>
            )}
          </form>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-secondary" onClick={this.hide}>
            Cancel
          </button>
          <Button
            label="Send"
            className="btn btn-primary"
            onClick={this.send}
            showSpinner={this.state.sending}
          />
        </ModalFooter>
      </SimpleModal>
    );
  }
}
